import Link from "next/link";
import { 푸터_Desktop } from "./푸터_Desktop";
import { 헤더_DesktopAB } from "./헤더_DesktopAB";
import { 프랜차이즈_목록 } from "./프랜차이즈_목록_Desktop";
import 섹션1_이미지1 from "/public/assets/pc/images/pic/img_section1_bg_marketbom1.webp";
import 섹션2_이미지1 from "/public/assets/pc/images/pic/img_section2_franchise1.webp";
import 섹션2_이미지2 from "/public/assets/pc/images/pic/img_section2_franchise2.webp";
import 섹션2_이미지3 from "/public/assets/pc/images/pic/img_section2_franchise3.webp";
import 섹션2_이미지4 from "/public/assets/pc/images/pic/img_section2_franchise4.webp";
import 섹션2_이미지5 from "/public/assets/pc/images/pic/img_section2_franchise5.webp";
import 섹션2_이미지6 from "/public/assets/pc/images/pic/img_section2_franchise6.webp";
import 화살표_아이콘 from "/public/assets/pc/images/icon/icon_move_link1.webp";
import { 랜딩_섹션2_Desktop } from "./랜딩_섹션2_Desktop";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";
import { pipe } from "@mobily/ts-belt";
import { useContext } from "react";
import { GrowthBookCTX, getValue } from "./util/GrowthBookCTX";

export const 프랜차이즈_Desktop = () => {
  const tracker = useTracker();
  const featureFlag = useContext(GrowthBookCTX);
  const simplifiedRegister = pipe(featureFlag, getValue("simplified-register"));

  return (
    <>
      <div id="wrap">
        <헤더_DesktopAB />
        <div id="container" className="service-infomation service-marketbom">
          <h2 className="blind">본문 내용</h2>
          <div
            className="section section1"
            style={{
              background: `url(${섹션1_이미지1.src}) no-repeat center center #fbf9f5`,
            }}            
          >
            <h3 className="blind">상단 소개</h3>
            <div className="inner">
              <dl>
                <dt><span style={{ fontWeight: 400 }}>프랜차이즈 전용</span> 수발주 프로그램</dt>
                <dd>
                  마켓봄은 2,000여 개의 프랜차이즈 본사가 사용하고 있습니다.
                </dd>
              </dl>
            </div>
          </div>
          <div className="section section2">
            <div className="inner">
              <h3>아직도 이런 문제를 가지고 계신가요?</h3>
              <div
                className="row type1"
                style={{
                  background: `url(${섹션2_이미지1.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">01</span>
                <dl>
                  <dt>
                    카톡, 문자, 전화로 <strong className="bold">불편한 주문</strong>
                    <br />
                    <span className="fc1">
                      가맹점 전용 주문앱으로 <strong className="bold">간단하게 주문</strong>
                    </span>
                  </dt>
                  <dd>
                    상품 이미지를 보고 장바구니에 담아 주문 하는 방식으로<br/>
                    가맹점주님들의 <strong className="bold">교육이 필요하지 않습니다.</strong>
                  </dd>
                </dl>
              </div>
              <div
                className="row type2"
                style={{
                  background: `url(${섹션2_이미지2.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">02</span>
                <dl>
                  <dt>
                    외상 거래로 <strong className="bold">미수금 증가</strong>
                    <br />
                    <span className="fc1">
                      선결제 방식으로 <strong className="bold">미수금 ZERO!</strong>
                    </span>
                  </dt>
                  <dd>
                    가상계좌와 신용카드를 이용한 선결제 방식으로 <strong className="bold">미수금 없이</strong>
                    <br />
                    <strong className="bold">본사 운영이 가능</strong>합니다. 선결제가 불가할 경우 한도설정과
                    <br />
                    알림서비스로 외상거래를 최소화할 수 있습니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type3"
                style={{
                  background: `url(${섹션2_이미지3.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">03</span>
                <dl>
                  <dt>
                    오래걸리는 <strong className="bold">매입처별 주문 전달</strong>
                    <br />
                    <span className="fc1">
                      자동 발주로 <strong className="bold">주문 마감과 동시에</strong>
                      <br/>
                      <strong className="bold">자동 전달</strong>
                    </span>
                  </dt>
                  <dd>
                    매입처별 주문내역을 취합할 필요없이 마감시간에
                    <br />
                    <strong className="bold">자동으로 문자가 발송</strong>됩니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type4"
                style={{
                  background: `url(${섹션2_이미지4.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">04</span>
                <dl>
                  <dt>
                    <strong className="bold">엑셀로 작업</strong>하는 매출분석
                    <br />
                    <span className="fc1">
                      담당자 지정으로 <strong className="bold">원클릭 분석</strong>
                    </span>
                  </dt>
                  <dd>
                    가맹점별 영업담당자, 배송담당자, 5단계 카테고리<br />
                    설정 등 <strong className="bold">여러 방법으로 매출분석이 가능</strong>합니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type5"
                style={{
                  background: `url(${섹션2_이미지5.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">05</span>
                <dl>
                  <dt>
                    <strong className="bold">매번 누락</strong>되는 공지사항
                    <br />
                    <span className="fc1">
                      모든 가맹점에 <strong className="bold">누락없이 한번에!</strong>
                    </span>
                  </dt>
                  <dd>
                    카톡, 문자가 아닌 가맹점 전용 앱을 통한 공지로<br />
                    <strong className="bold">모든 가맹점에 누락없이 공지</strong>가 가능합니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type6"
                style={{
                  background: `url(${섹션2_이미지6.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">06</span>
                <dl>
                  <dt>
                    <strong className="bold">사무실에서만</strong> 해야하는 업무!
                    <br />
                    <span className="fc1">
                      설치 없이 <strong className="bold">언제 어디서나 접속</strong>
                    </span>
                  </dt>
                  <dd>
                    인터넷이 가능한 공간이면<br />
                    <strong className="bold">언제 어디서든 업무가 가능</strong>합니다.
                  </dd>
                </dl>
              </div>              
            </div>
          </div>
          <div id="container" className="main">
            <프랜차이즈_목록 />
          </div>
          <div className="section section3">
            <div className="inner">            
              <div style={{textAlign: "center", fontSize: "40px", lineHeight: "46px", fontWeight: 700}}>프랜차이즈 대표님 인터뷰</div>
              <랜딩_섹션2_Desktop interviewOnly={true} />
              <div className="btn-wrap-nomargin">
                <Link
                  href={
                    simplifiedRegister
                      ? 링크.마켓봄_간편가입_실험_링크_PC
                      : 링크.마켓봄_회원가입
                  }
                  style={{
                    background: `url(${화살표_아이콘.src}) no-repeat 463px center #fe6b37`,
                  }}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "MARKETBOM",
                      depth2: "회원가입",
                      depth3: "마켓봄",
                      indicator: "회원가입",
                    })
                  }
                >
                  마켓봄 가입하고 상담받기
                </Link>
              </div>
            </div>
          </div>
        </div>

        <푸터_Desktop />
      </div>
    </>
  );
};
